// extracted by mini-css-extract-plugin
export default {"mtn__header":"styles_mtn__header__GWJ+8","titleContainer":"styles_titleContainer__riAHR","dpContainer":"styles_dpContainer__h+slm","dp":"styles_dp__EBQVo"};